'use client';

import { NewsTagGtmEventType } from '@fe-common-ui/Button';
import Folder from '@fe-common-ui/Button/theme/Folder';
import NewsTag from '@fe-common-ui/Button/theme/NewsTag';
import sanitize from '@fe-common-utils/libs/sanitize';
import useFolder from '@fe-news/hooks/use-folder';
import { styled } from '@linaria/react';
import { useRef } from 'react';

const View = styled.div<{ isFold?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  overflow: hidden;
  max-height: ${({ isFold }) => (isFold ? '80px' : '100%')};
`;

type TagsProps = {
  tags: HotKeyword[];
};

const Tags = ({ tags }: TagsProps) => {
  const tagsReference = useRef<HTMLDivElement | null>(null);
  const { isExpand, setIsExpand, order: insertButtonOrder } = useFolder(tagsReference);

  const onClickHandler = () => setIsExpand(v => !v);

  return (
    <View ref={tagsReference} isFold={!isExpand}>
      {tags?.map(({ tag }: { tag: string }, index: number) => {
        const link = `/search?q=${sanitize(tag)}`;

        return (
          <NewsTag
            key={`${tag}-${index}`}
            order={index}
            link={link}
            gtmEventType={NewsTagGtmEventType.NEWS_SEARCH_HOT_TAG}
            tag={tag}
          />
        );
      })}
      <Folder
        active={isExpand}
        order={insertButtonOrder}
        hide={insertButtonOrder === -1}
        onClick={onClickHandler}
      />
    </View>
  );
};

export default Tags;
